import React from 'react';
import { isEqual, pick } from 'underscore';

interface RectProperties extends ClientRect {}

interface RectChildrenArgs {
  ref: React.RefObject<HTMLDivElement>;
  rect: RectProperties;
}

interface RectProps {
  children: (args: RectChildrenArgs) => React.ReactNode;
}

interface RectState extends RectProperties {}

export class Rect extends React.Component<RectProps, RectState> {
  ref = React.createRef<HTMLDivElement>();
  interval: number;

  state: RectState = {
    bottom: 0,
    height: 0,
    left: 0,
    right: 0,
    top: 0,
    width: 0,
  };

  componentDidMount() {
    this.calculateRect();
  }

  render() {
    return this.props.children({
      ref: this.ref,
      rect: this.state,
    });
  }

  calculateRect = () => {
    setTimeout(() => {
      if (this.ref.current) {
        const rect: RectState = pick(
          this.ref.current.getBoundingClientRect(),
          'bottom',
          'height',
          'left',
          'right',
          'top',
          'width',
        );

        if (!isEqual(rect, this.state)) {
          this.setState(rect, this.calculateRect);
        }
      }
    }, 20);
  };
}
